/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Send = ({ color = 'forest', height = 17, ...props }) => {
  return (
    <svg
      width={17}
      height={height}
      viewBox="0 0 20 20"
      sx={{ fill: color }}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0V2H16.475L9.066 9.165L10.536 10.457L18 2.926V8H20V0H12ZM18 12H20V20H0V0H8V2H2V18H18V12Z"
        fill={color}
      />
    </svg>
  )
}

Send.propTypes = {
  color: string,
  height: number,
}

export default Send
